import type { NskResponse } from "~/models/Api";
import type { CompanyVendor, CompanyVendorEdit } from "~/models/CompanyVendor";
import {
	deleteRequest,
	postRequest,
	putRequest
} from "~/utils/api/api_handler";

const paths = {
	create: "/company_vendors",
	destroy: "/company_vendors/:id",
	update: "/company_vendors/:id",
	updateSeq: "/company_vendors/update_seq"
};

export const create = async (
	companyVendor: CompanyVendorEdit,
	invite: boolean
): Promise<NskResponse> => postRequest(paths.create, { companyVendor, invite });

export const update = async (
	companyVendor: CompanyVendorEdit,
	companyVendorId: number
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":id", String(companyVendorId)), {
		companyVendor
	});

export const destroy = async (companyVendorId: number): Promise<NskResponse> =>
	deleteRequest(paths.destroy.replace(":id", String(companyVendorId)));

export const updateSeq = async (
	companyVendors: CompanyVendor[]
): Promise<NskResponse> => postRequest(paths.updateSeq, { companyVendors });
